import { inventoryCategories, spaceCategories } from "_constants";
import includes from "lodash/includes";
import { defaultUnitsSelector } from "selectors/currentUser";

import spaceSort from "./spaceSort";

export const withInventory = (spaceCategory) =>
  includes(Object.keys(inventoryCategories), spaceCategory);

export const withAreaCapacity = (spaceCategory) => !withInventory(spaceCategory);

export const isAreaPrimary = (spaceCategory) => includes(["office", "other"], spaceCategory);

export const isCapacityPrimary = (spaceCategory) =>
  includes(["meeting", "residential"], spaceCategory);

export const defaultSpaceUnits = (state, spaceCategory) => {
  const { currency, sizeUnit } = defaultUnitsSelector(state);
  const { period, unit = sizeUnit } = spaceCategories[spaceCategory] || {};

  return {
    currency,
    period,
    unit: isAreaPrimary(spaceCategory) ? sizeUnit : unit,
    minContractLength: {
      period,
    },
  };
};

export { spaceSort };

export default defaultSpaceUnits;
